import React from "react";
import ActivateIcon from "./img/activateIcon.svg";
import AgencySelectorIcon from "./img/agencySelector.svg";
import EmailIcon from "./img/emailIcon.svg";
import PasswordIcon from "./img/passwordKey.svg";
import InvalidLink from "./img/invalidLink.svg";
import GreenTick from "./img/greenTick.svg";
import "./ImgWithTitle.css";

export default function ImgWithTitle(props) {
  const {
    titleText,
    subText,
    icon,
    style,
    headerFontSize = "1.875rem",
    subTextFontSize = "0.875rem",
    imgSize = "7rem",
  } = props;

  const headerImg = () => {
    switch (icon) {
      case "agency":
        return (
          <img
            loading="lazy"
            src={AgencySelectorIcon}
            alt="agencyselector"
            style={{ width: imgSize, height: imgSize }}
          />
        );
      case "Live":
        return (
          <img
            loading="lazy"
            src={ActivateIcon}
            alt="activateicon"
            style={{ width: imgSize, height: imgSize }}
          />
        );
      case "Insights":
        return (
          <img
            loading="lazy"
            src={EmailIcon}
            alt="emailicon"
            style={{ width: imgSize, height: imgSize }}
          />
        );
      case "Users":
        return (
          <img
            loading="lazy"
            src={PasswordIcon}
            alt="passwordicon"
            style={{ width: imgSize, height: imgSize }}
          />
        );
      case "Invalid":
        return (
          <img
            loading="lazy"
            src={InvalidLink}
            alt="invalidlink"
            style={{ width: imgSize, height: imgSize }}
          />
        );
      case "Success":
        return (
          <img
            loading="lazy"
            src={GreenTick}
            alt="greentick"
            style={{ width: imgSize, height: imgSize }}
          />
        );
      default:
        return null;
    }
  };


  const calculateMargin = (size) => {
    const sizeInPixels = parseFloat(size);
    const marginTop = sizeInPixels * 0.15;
    const marginBottom = sizeInPixels * 0.1;
    return {
      marginTop: `${marginTop}rem`,
      marginBottom: `${marginBottom}rem`,
    };
  };

  const textMargins = calculateMargin(imgSize);

  return (
    <div className="img-with-class-container" style={style}>
      {headerImg()}
      <div
        className="img-with-class-header-text"
        style={{ fontSize: headerFontSize, marginTop: textMargins.marginTop }}
      >
        {titleText}
      </div>
      {subText && (
        <div
          className="img-with-class-subtext"
          style={{
            fontSize: subTextFontSize,
            marginTop: textMargins.marginBottom,
          }}
        >
          {subText}
        </div>
      )}
    </div>
  );
}
